import fetch from 'cross-fetch';
import { FacebookLoginAction, FacebookLoginResponse } from './facebook-login';
import { isWebPlatform } from '../../../components/forms/login-hub/common/login-hub-helpers';

export class RemoteFacebookLoginAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: FacebookLoginAction = async (route: string): Promise<FacebookLoginResponse> => {
		const base: string = this.baseUrl || '';
		const platform: string = isWebPlatform() ? 'web' : 'mobile';

		const response: Response = await fetch(`${base}/api/auth/facebook/login?platform=${platform}`, {
			mode: 'cors',
			credentials: 'include',
			method: 'GET',
			headers: {
				'X-Anchor': route,
			},
		});

		const jsonResponse = await response.json();
		return { ...jsonResponse, status: response.status };
	};
}
